module.exports = __webpack_public_path__ + "static/img/data-head-bright.486d26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dataCenter/data-head-bright.png
// module id = SJXV
// module chunks = 94